






























import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import PaymentSubmit from '@/Payment/PaymentMethods/PaymentSubmit.vue';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import PaymentMethodMixin from '@/Payment/PaymentMethods/PaymentMethodMixin';
import { PaymentResult } from '@/Payment/PaymentResult';
import KeyValuePairGrid from '@/Shared/KeyValuePairGrid.vue';
import Five9Completion from '@/Payment/Five9Completion.vue';
import { PaymentSubmission } from '@/Payment/PaymentSubmission';
import { PaymentSource, HostedPaymentType } from '@/Payment/Enums';
import I18nMixin from '@/Shared/I18nMixin';

const component = mixins(LocationBasedMixin, PaymentMethodMixin, I18nMixin).extend({
    components: {
        KeyValuePairGrid,
        Five9Completion
    },
    props: {
        controllerName: {
            type: String,
            required: true
        }
    },
    computed: {
        submission(): PaymentSubmission<any> {
            return {
                toPay: this.recordsToPay,
                customer: this.customer,
                paymentMethod: {
                    paymentMethod: this.method,
                    paymentSource: this.source,
                    // Will be replaced by the controller method, but cannot be left empty
                    // or it will fail validation
                    callbackController: 'replaceme',
                }
            };
        },
        i18nPrefix() {
            return 'payment.five9Payment';
        }
    },
    data() {
        return {
            paymentResult: null as PaymentResult | null,
            HostedPaymentType
        };
    },
    methods: {
        async afterSubmit(paymentResult: PaymentResult) {
            this.paymentResult = paymentResult;
        }
    }
});

export default component;
